module.exports = __webpack_public_path__ + "img/quit-icon.eee186d2.svg";